<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <v-btn :to="{ name: 'Reports' }" color="primary" outlined right fab small class="mr-4"><v-icon>mdi-close</v-icon></v-btn>
      <div class="title primary--text">{{ section }}</div>
    </div>

    <v-flex xs12>
      <v-card class="mx-auto mt-5" tile>
        <template>
          <v-container class="mb-0 pb-0">
            <v-row>

              <!-- Filtro por periodo -->
              <v-col cols="12" md="9" class="text-right pb-0 pt-5">
                <date-tab-filter :dates="dates" :period="period" v-on:update:filter="filter = $event" v-on:update:period="period = $event" v-on:update:dates="dates = $event"></date-tab-filter>
              </v-col>

              <!-- Filtro por rango de fecha -->
              <v-col cols="12" md="3" class="pb-0 pt-1 text-right">
                <date-filter :dates="dates" :filter="filter" v-on:update:change="dates = $event"></date-filter>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template>
          <v-data-table
              :headers="headers"
              :items="sales"
              item-key="id"
              :footer-props="{ 'items-per-page-options': [50], 'items-per-page-text': 'Ventas por Página'}"
              class="elevation-1">

              <!-- Columna Unit Cost -->
              <template v-slot:item.cost="{ item }" class="align-center">
                {{ item.cost | toFixNumber(2) | numberWithComma | prefix('$') }}
              </template>

              <!-- Columna Price -->
              <template v-slot:item.unitprice="{ item }" class="align-center">
                {{ item.unitprice | toFixNumber(2) | numberWithComma | prefix('$') }}
              </template>

              <!-- Columna Percent Cost -->
              <template v-slot:item.percentCost="{ item }" class="align-center">
                {{ item.percentCost | toFixNumber(2) | numberWithComma | sufix('%') }}
              </template>

              <!-- Columna Sales -->
              <template v-slot:item.total="{ item }" class="align-center">
                {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
              </template>

              </v-data-table>
        </template>
      </v-card>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import DateTabFilter from '../components/DateTabFilter'
import DateFilter from '../components/DateFilter'

export default {
  name: 'sales-before-tax',
  components: { DateTabFilter, DateFilter },
  data () {
    return {
      section: this.$i18n.t('reports.salesBeforeTax'),
      overlay: false,
      filter: 0,
      headers: [
        // { text: 'Cat', align: 'left', value: 'category', sortable: false },
        { text: 'Platillo', align: 'left', value: 'recipeName', sortable: false },
        { text: 'Costo Uni', align: 'right', value: 'cost', sortable: false },
        { text: '% Cost', align: 'right', value: 'percentCost', sortable: false },
        { text: 'Precio Venta', align: 'right', value: 'unitPrice', sortable: false },
        { text: 'Ventas', align: 'right', value: 'total', sortable: false }
        // { text: 'Ventas Totales', align: 'center', value: 'sales_total', sortable: false }
      ],
      sales: [],
      dates: [],
      period: 'week'
    }
  },
  computed: {
    ...mapGetters(['restaurant']),
    queryParams () {
      const { dates, period } = this.$route.query
      return { dates, period }
    }
  },
  async mounted () {
    this.dates = this.queryParams.dates
    this.period = this.queryParams.period
    await this.getSalesBeforeTaxes()
  },
  methods: {
    async getSalesBeforeTaxes () {
      let [ fromDate ] = this.dates
      this.overlay = true
      try {
        const salesByDish = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/reports/sales-by-dish`, {
          date: fromDate,
          type: this.period
        })
        this.sales = salesByDish
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  },
  watch: {
    queryParams (val) {
      if (val) {
        this.getSalesBeforeTaxes()
      }
    },
    dates () {
      this.getSalesBeforeTaxes()
    },
    period () {
      this.getSalesBeforeTaxes()
    }
  }
}
</script>
